import { getTestIds } from 'seagull/utils/TestIds';
export const deleteContactModalTextsPath = 'pages.contactsDashboard.deleteModal';
export const GetDeleteContactModalTID = (parentTestId)=>getTestIds(parentTestId);
